/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAdminSavingsTransfers} from '../api'

 export const useQueryGetAdminSavingsTransfers = createReactQueryHook('getAdminSavingsTransfers', getAdminSavingsTransfers)
